import { subdomains } from "@/common/consts";
import SynonymsHome from "@/pages/Synonyms/Home/SynonymsHome.vue";
import SynonymDetail from "@/pages/Synonyms/Detail/SynonymDetail.vue";
import SynonymIndex from "@/pages/Synonyms/Index/SynonymIndex.vue";
import SynonymNoResults from "@/pages/Synonyms/NoResults/SynonymNoResults.vue";
import ExperimentOverride from "@/pages/ExperimentOverride/ExperimentOverride.vue";

export default [
    {
        path: "/",
        name: "Synonyms",
        meta: {
            subdomain: subdomains.THESAURUS
        },
        component: SynonymsHome
    },
    {
        path: "/abexp/:channel?",
        name: "ExperimentOverride",
        component: ExperimentOverride
    },
    {
        path: "/:slug",
        name: "SynonymDetail",
        meta: {
            subdomain: subdomains.THESAURUS
        },
        props: true,
        component: SynonymDetail
    },
    {
        path: "/index/:index",
        name: "SynonymIndex",
        meta: {
            subdomain: subdomains.THESAURUS
        },
        props: true,
        component: SynonymIndex
    },
    {
        path: "/404/no-results",
        name: "SynonymNoResults",
        meta: {
            subdomain: subdomains.THESAURUS
        },
        props: true,
        component: SynonymNoResults
    },
    {
        path: "/*/",
        name: "SynonymNoResultsSub",
        meta: {
            subdomain: subdomains.THESAURUS
        },
        props: true,
        component: SynonymNoResults
    }
];



// WEBPACK FOOTER //
// ./src/router/routes/subdomain.thesaurus.js